import type { UseQueryResult } from '@tanstack/react-query'
import { usePrismicDashboardItems, type DashboardItem } from '@dhl/dashboard'
import { getConfig } from '~/config/index.js'

const parseItem = (item: DashboardItem) => {
  switch (item.linkedDocument?.type) {
    case 'promotion':
      return {
        ...item,
        linkUrl: `{relative}promotions/${item.linkedDocument.id}`,
      }
    default:
      return item
  }
}

export const useDashboardItems = (lang: string): UseQueryResult<DashboardItem[]> => {
  const { prismic } = getConfig()
  const result = usePrismicDashboardItems(prismic.endpoint, lang)

  const items = result.data?.map(parseItem) ?? []

  return { ...result, data: items } as UseQueryResult<DashboardItem[]>
}
